<script>
  import Main from './Main.svelte'
  export let _input
  export let _output
</script>

<main>
  <Main _input={_input} _output={_output} />
</main>
